/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Snippet_UrlInputs */

const en_mcp_snippet_url = /** @type {(inputs: Mcp_Snippet_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP URL`)
};

const es_mcp_snippet_url = /** @type {(inputs: Mcp_Snippet_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de MCP`)
};

/**
* | output |
* | --- |
* | "MCP URL" |
*
* @param {Mcp_Snippet_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_snippet_url = /** @type {((inputs?: Mcp_Snippet_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Snippet_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_snippet_url(inputs)
	return en_mcp_snippet_url(inputs)
});